import { createSvgComponent } from "../../icon/createSvgComponent";
import ChatbubbleTyping from "@core/__generated__/icon/figma/chatbubble-typing.svg";
export default createSvgComponent(ChatbubbleTyping);